import { forwardRef } from "react";

const GlowButton = forwardRef(function GlowButton(
    { children, variant = "cyan", size = "md", className = "", as: Tag = "button", ...rest },
    ref
) {
    const sizes = {
        sm: "px-4 py-2 text-xs",
        md: "px-6 py-3 text-sm",
        lg: "px-8 py-4 text-base",
    };
    const palettes = {
        cyan: `
            bg-gradient-to-b from-[rgba(0,224,232,0.18)] to-[rgba(0,224,232,0.06)]
            border-tca-cyan/70 text-tca-cyan-hi
            hover:text-white hover:border-tca-cyan
            shadow-glow-cyan-xs hover:shadow-glow-cyan-lg
        `,
        magenta: `
            bg-gradient-to-b from-[rgba(255,107,255,0.16)] to-[rgba(255,107,255,0.05)]
            border-tca-magenta/65 text-tca-magenta
            hover:text-white hover:border-tca-magenta
            shadow-glow-magenta
        `,
    };

    return (
        <Tag
            ref={ref}
            className={`
                group relative inline-flex items-center justify-center gap-2
                font-mono-tight font-semibold uppercase tracking-[0.18em]
                rounded-full border backdrop-blur-sm
                transition-all duration-300 ease-out
                ${sizes[size]} ${palettes[variant]}
                hover:-translate-y-[1px]
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tca-cyan/70
                ${className}
            `}
            {...rest}
        >
            {/* Pulse halo on hover */}
            <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                    boxShadow:
                        variant === "cyan"
                            ? "0 0 0 1px rgba(0,224,232,0.4), 0 0 28px rgba(0,224,232,0.6), 0 0 64px rgba(0,224,232,0.3)"
                            : "0 0 0 1px rgba(255,107,255,0.40), 0 0 28px rgba(255,107,255,0.55), 0 0 64px rgba(255,107,255,0.28)",
                    animation: "pulse-glow 2.6s ease-in-out infinite",
                }}
            />
            <span className="relative z-10">{children}</span>
        </Tag>
    );
});

export default GlowButton;
